
import { motion } from "framer-motion";
import MainLayout from "@/components/layout/MainLayout";
import BigFiveTest from "@/components/personality/BigFiveTest";
import PageSEO from "@/components/seo/PageSEO";

const PersonalityTest = () => {
  const breadcrumbs = [
    {
      position: 1,
      name: "Início",
      item: "https://youcalm.org/app"
    },
    {
      position: 2,
      name: "Testes de Personalidade",
      item: "https://youcalm.org/testes-personalidade"
    },
    {
      position: 3,
      name: "Teste Big Five",
      item: "https://youcalm.org/teste-personalidade"
    }
  ];

  const structuredData = {
    "@type": "Course",
    "name": "Teste de Personalidade Big Five",
    "description": "Teste científico validado que avalia os cinco grandes fatores de personalidade para autoconhecimento profundo.",
    "provider": {
      "@type": "Organization",
      "name": "YouCalm"
    },
    "educationalLevel": "Beginner",
    "timeRequired": "PT15M",
    "courseMode": "online"
  };

  return (
    <MainLayout>
      <PageSEO 
        title="Teste de Personalidade Big Five - YouCalm | Autoconhecimento Científico"
        description="Descubra seu perfil psicológico completo com nosso teste Big Five validado cientificamente. Obtenha insights profundos sobre sua personalidade em 15 minutos."
        canonicalUrl="https://youcalm.org/teste-personalidade"
        keywords="teste personalidade big five, autoconhecimento, perfil psicológico, cinco fatores personalidade, teste científico"
        pageName="Teste Big Five"
        pageType="Course"
        structuredData={structuredData}
        breadcrumbs={breadcrumbs}
      />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <BigFiveTest version="full" />
      </motion.div>
    </MainLayout>
  );
};

export default PersonalityTest;
